import type { SVGProps } from "react";
import * as React from "react";

const SvgIconAzure = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 76 75"
    {...props}
  >
    <rect
      width={75}
      height={75}
      x={0.205}
      y={-0.009}
      fill="#fff"
      rx={14}
    />
    <path
      fill="url(#Icon_azure_svg__a)"
      d="M27.76 11.71h16.138L27.146 61.347a2.57 2.57 0 0 1-2.438 1.75H12.15a2.568 2.568 0 0 1-2.434-3.39l15.608-46.245a2.57 2.57 0 0 1 2.438-1.75"
    />
    <path
      fill="#0078D4"
      d="M51.211 45.003h-25.59a1.185 1.185 0 0 0-.81 2.05l16.445 15.349c.478.446 1.109.695 1.764.695h14.49z"
    />
    <path
      fill="url(#Icon_azure_svg__b)"
      d="M27.76 11.711a2.55 2.55 0 0 0-2.443 1.784L9.734 59.665a2.566 2.566 0 0 0 2.422 3.432H25.04a2.75 2.75 0 0 0 2.114-1.797l3.107-9.159 11.1 10.354a2.63 2.63 0 0 0 1.653.602h14.436l-6.331-18.094-18.458.005L43.957 11.71z"
    />
    <path
      fill="url(#Icon_azure_svg__c)"
      d="M48.373 13.459a2.57 2.57 0 0 0-2.435-1.748H27.953a2.57 2.57 0 0 1 2.434 1.748l15.609 46.247a2.57 2.57 0 0 1-2.435 3.391h17.986a2.57 2.57 0 0 0 2.434-3.39z"
    />
    <defs>
      <linearGradient
        id="Icon_azure_svg__a"
        x1={33.642}
        x2={16.883}
        y1={15.518}
        y2={65.03}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#114A8B" />
        <stop
          offset={1}
          stopColor="#0669BC"
        />
      </linearGradient>
      <linearGradient
        id="Icon_azure_svg__b"
        x1={38.878}
        x2={35.001}
        y1={38.592}
        y2={39.903}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0.3} />
        <stop
          offset={0.071}
          stopOpacity={0.2}
        />
        <stop
          offset={0.321}
          stopOpacity={0.1}
        />
        <stop
          offset={0.623}
          stopOpacity={0.05}
        />
        <stop
          offset={1}
          stopOpacity={0}
        />
      </linearGradient>
      <linearGradient
        id="Icon_azure_svg__c"
        x1={36.746}
        x2={55.142}
        y1={14.075}
        y2={63.087}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3CCBF4" />
        <stop
          offset={1}
          stopColor="#2892DF"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgIconAzure;
